/* global phpVars */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; import './autoload/lazyload.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';
//import { set } from 'ramda';

/**
 * Init foundation
 */

jQuery(document).ready(function($) {
  $.setCookie = function(name,value) {
    var d = new Date();
    d.setFullYear(new Date().getFullYear() + 1);
    var expires = d.toUTCString();
    value = encodeURIComponent(value);
    var cookieString = name+"="+value+"; expires="+expires+"; path=/; domain=.jordanwinery.com;";
    document.cookie = cookieString;
  };

  $.getCookie = function(name) {
    var search = name + "=";
    if (document.cookie.length > 0) { // if there are any cookies
      var offset = document.cookie.indexOf(search);
      if (offset !== -1) { // if cookie exists
        offset += search.length;
        // set index of beginning of value
        var end = document.cookie.indexOf(";", offset);
        // set index of end of cookie value
        if (end === -1) {
          end = document.cookie.length;
        }
        return decodeURIComponent(document.cookie.substring(offset, end));
      }
    }
  };
});

$(document).foundation();

(function($,sr){

  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  var debounce = function (func, threshold, execAsap) {
      var timeout;

      return function debounced () {
          var obj = this, args = arguments;
          function delayed () {
              if (!execAsap)
                  func.apply(obj, args);
              timeout = null;
          }

          if (timeout)
              clearTimeout(timeout);
          else if (execAsap)
              func.apply(obj, args);

          timeout = setTimeout(delayed, threshold || 100);
      };
  }
  // smartresize
  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function() {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function() {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scroll to element
 */

function scrollToTarget($target) {
  if (!$target.length) {
    return;
  }

  var top = $target.offset().top;

  $('html, body')
    .stop()
    .animate(
      {
        scrollTop: top,
      },
      1000
    );
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function() {
  $('.menu-icon').click(function() {
    $(this).toggleClass('is-active');
    $('#main-menu').toggleClass('is-active');
  });
  $('.submenu-toggle').click(function() {
    if ($(this).hasClass('is-active') ) {
      $('#main-menu .is-active').removeClass('is-active');
    } else {
      $('#main-menu .is-active').removeClass('is-active');
      $(this).addClass('is-active');
      $(this).prev().addClass('is-active');
    }
  });
  /**
   * Load More Wines
   */
  $.windowWidth = 1024;
  $.windowHeight = 768;
  function getViewportDimensions() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
      a = 'client';
      e = document.documentElement || document.body;
    }
    $.windowWidth = e[ a+'Width' ];
    $.windowHeight = e[ a+'Height' ];
  }
   $(window).smartresize(function(){
       getViewportDimensions();
       if ($.windowWidth > 1024) {
        $('.menu-icon').removeClass('is-active');
        $('#main-menu').removeClass('is-active');
        $('#main-menu .is-active').removeClass('is-active');
        console.log('hidden');
       }
   });


  //function windowResizeBehaviour() {
  //}

  //if ( $("body").hasClass("desktop-device") ) {
  //  $(".parallax").simpleParallax(0.5, $.mobileBreakPoint);
  //}

  $('.js-load-trade-wines').on('click', function(e) {
    e.preventDefault();
    let $this = $(this);
    if ($this.hasClass('is-loading')) return;

    /* eslint-disable no-undef */
    $this.addClass('is-loading');
    let data = '';
    data += 'action=' + $this.attr('data-action');
    data += '&current_page=' + $this.attr('data-current-page');
    data += '&offset=' + $('.js-products-grid > .cell').length;
    data += '&nonce=' + phpVars.nonce;

    $.ajax({
      url: phpVars.url,
      dataType: 'json',
      data: data,
      /* eslint-enable no-undef */
    })
      .done(function(response) {
        $this
          .closest('.trade-products-grid')
          .find('.js-products-grid')
          .append(response.content);

        if (
          $this.attr('data-max-length') <= $('.js-products-grid > .cell').length
        )
          $this.remove();
      })
      .always(function() {
        $this.removeClass('is-loading');
      });
  });
  /**
   * Show/Hide Multiple Shipping Form
   */
  $('.js-open-multiple-addresses').on('click', function() {
    $('.js-shipping-main-content').hide();
    $('.js-shipping-multiple-addresses').show();
  });

  $('.js-close-multiple-addresses').on('click', function() {
    $('.js-shipping-multiple-addresses').hide();
    $('.js-shipping-main-content').show();
  });
  /**
   * Slide toggle
   * NOTICE: Add Foundation accordion if items will be more then one
   */
  $('.js-slide-toggle').on('click', '.js-slide-title', function() {
    $(this)
      .next()
      .slideToggle();
  });
  /**
   * Custom handler to proceed to checkout
   */
  $('.js-custom-proceed-to-checkout').on('click', function(e) {
    e.preventDefault();
    $('.checkout-button')[0].click();
  });
  /**
   * Filters Handler
   */
  $('body').on('click', '.js-pagination-container a', function(e) {
    e.preventDefault();
    let filter = $('.js-form-filter');
    if (!filter.length) return;
    let $this = $(this),
      inputPage = filter.find('[name="current_page"]'),
      inputPageVal = parseInt(inputPage.val());
    if ($this.hasClass('next')) {
      inputPage.val(inputPageVal + 1);
    } else if ($this.hasClass('prev')) {
      inputPage.val(inputPageVal - 1);
    } else {
      inputPage.val($this.text());
    }
    filter.submit();
  });

  // Load more button pagination
  $('body').on('click', '.js-loadmore', function() {
    let $this = $(this);
    if ($this.hasClass('is-loading')) return false;

    $this.addClass('is-loading');
    let action = $this.attr('data-action'),
      currentPage = parseInt($this.attr('data-current-page')),
      maxPages = parseInt($this.attr('data-max-pages')),
      $formFilter = $('.js-form-filter'),
      currentFilterValues = '';

    if ($formFilter.length) {
      currentFilterValues = $formFilter.serialize();
      currentFilterValues = currentFilterValues.replace(
        'action=jw_get_recipes',
        'action=' + action
      ); // replace action
    } else {
      currentFilterValues += 'action=' + action;
    }

    /* eslint-disable no-undef */
    if ('posts' in phpVars) {
      currentFilterValues = currentFilterValues + '&posts=' + phpVars.posts;
    }

    currentPage++;
    $.ajax({
      url: phpVars.url,
      dataType: 'json',
      data:
        currentFilterValues +
        '&current_page=' +
        currentPage +
        '&nonce=' +
        phpVars.nonce,
      /* eslint-enable no-undef */
    })
      .done(function(response) {
        $this
          .closest('.cell')
          .prev()
          .after(response.content);

        if (currentPage === maxPages) {
          $this.remove();
          return;
        }

        $this.attr('data-current-page', currentPage);
      })
      .always(function() {
        $this.removeClass('is-loading');
      });
  });

  $('.js-form-filter')
    .submit(function() {
      //console.log('getting posts');
      let $this = $('.js-form-filter');
      if ($this.hasClass('js-lead-to-archive')) {
        window.location = $this.attr('action');
        return false;
      }
      if ($this.hasClass('is-loading')) return false;
      /* eslint-disable no-undef */
      let postsArgs = '';
      if ('posts' in phpVars) {
        postsArgs = '&posts=' + phpVars.posts; // set posts args from php
      }
      //console.log($this.serialize());
      $.ajax({
        url: phpVars.url,
        dataType: 'json',
        data: $this.serialize() + postsArgs + '&nonce=' + phpVars.nonce, // form data
        /* eslint-enable no-undef */
      })
        .done(function(response) {
          //console.log('have posts');
          //console.log(phpVars);
          //console.log($this.serialize());
          //console.log(postsArgs);
          $('.js-posts-container').html(response.content);
        })
        .always(function() {
          $this.removeClass('is-loading');
        });
      return false;
    })
    .on('change', 'select', function() {
      // this.form.submit();
      //console.log('filter selected');
      let $form = $(this).closest('form');
      $form.find('[name="current_page"]').val(1);
      $form.submit();
    });
  /**
   * Back to Top
   */
  $('.js-anchor-top').on('click', function() {
    let $topAnchor = $('.header');
    scrollToTarget($topAnchor);
    $(this).blur();
  });
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover, .image-cover').length) {
    objectFitImages('.of-cover, .image-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function(event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on('change keyup', '.gfield input, .gfield textarea', function() {
    let $field = $(this).closest('.gfield');
    if ($field.hasClass('gfield_error') && $(this).val().length) {
      $field.find('.validation_message').hide();
    } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
      $field.find('.validation_message').show();
    }
  });

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  // /**
  //  * Close responsive menu on orientation change
  //  */
  // $(window).on('orientationchange', function() {
  //   setTimeout(function() {
  //     if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
  //       $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
  //     }
  //   }, 200);
  // });

  resizeVideo();

  // Header search button action {
  // $('.header-actions__button.search-button').on('click', function() {
  //   $('.header-actions__item-search').fadeIn(300);
  //   return false;
  // });

  // $(document).click(function(e) {
  //   if ($(e.target).closest('.header-actions__item-search').length) return;
  //   $('.header-actions__item-search').fadeOut(300);
  // });
  // } Header search button action
  // Dropdown Select {
  $('.dropdown-select').on('click', function() {
    if ( $(this).hasClass('active') ) {
      $('.dropdown-select__list').hide(300);
      $(this).removeClass('active');
    } else {
      $(this).find('.dropdown-select__list').toggle(300);
      $(this).addClass('active');
    }
  });

  $(document).on('click', function(e) {
    var container = $('.dropdown-select');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.dropdown-select')
        .find('.dropdown-select__list')
        .hide(300);
      $('.dropdown-select').removeClass('active');
    }
  });

  // NEED To IGNORE IN SHOP BECAUSE OF DIFFERENT USAGE

  if (
    $('body').hasClass('page-template-template-shop') ||
    $('body').hasClass('page-template-page-collection')
    // $('body').hasClass('tax-visit_category') ||
    // $('body').hasClass('tax-reward_types') ||
    // $('body').hasClass('tax-event_type') ||
    // $('body').hasClass('tax-event_location')
  ) {
    // console.log('shop');
  } else {
    $('.dropdown-select a:not(.passthrough)').on('click', function() {
      console.log('filter selected');
      if (typeof $(this).attr('data-value') !== 'undefined') {
        var data_value = $(this).attr('data-value');
      }

      var value = $(this).html();

      $(this)
        .closest('.dropdown-select')
        .find('.dropdown-select__selected')
        .html(value);
      $(this)
        .closest('td.value')
        .find('select')
        .val(value)
        .change();

      if (typeof data_value !== 'undefined') {
        $(this)
          .closest('div.cell')
          .find('select')
          .val(data_value)
          .change();
      }

      // Hide after clicked
      $(this)
        .closest('.dropdown-select')
        .find('.dropdown-select__list')
        .hide(300);
      return false;
    });
  }
  // } Dropdown Select

  // Table responsive accordions {
  $('.table-s tbody td:nth-child(1)').on('click', function() {
    if ($(window).width() < 640) {
      $(this)
        .closest('tr')
        .toggleClass('active');
      $(this)
        .closest('tr')
        .find('td:not(:nth-child(1))')
        .slideToggle(250);
    }
  });
  // } Table responsive accordions
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function() {
  $('.rvl_modal_wrap').click(function(e) {
    e.preventDefault();
    $('.rvl_modal_wrap').fadeOut(500);
    $.setCookie('rvl_modal',1);
  });

  $('.video-holder.deferred').each(function() {
    console.log('populating videos');
    var url = $(this).data('src');
    var settings = $(this).data('settings');
    var classes = $(this).data('classes');
    $(this).html('<video src="'+url+'" '+settings+' class="'+classes+'"></video>');
  });


  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
  // $('.submenu--type-sidebar').each(function() {
  //   $(this).outerHeight(
  //     $(this)
  //       .next()
  //       .outerHeight()
  //   );
  // });
  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    threshold: 0.3,
    once: true,
    onShown: function(element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function(i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function() {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });
});


/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function() {
  // jQuery code goes here
  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function() {
  // jQuery code goes here
});
